(function (window) {
  const HELP = "https://help.thestackhouse.com/hc/en-us/articles/36118504349965-How-to-Convert-Your-File-from-CMYK-to-RGB";
  const MESSAGE = "This saved image uses CMYK color mode and can’t be used for a new print order. Please convert it to RGB and upload the RGB copy.";

  function metadata(image) {
    return { ...(image?.image_metadata || {}), ...(image?.metadata || {}) };
  }

  function needsRgb(image) {
    const meta = metadata(image);
    const mode = String(image?.source_color_mode || meta.original_mode || meta.mode || "").trim().toLowerCase();
    return image?.print_order_eligible === false || image?.print_order_block_reason === "cmyk" || meta.is_cmyk === true || mode === "cmyk";
  }

  function cmykError(message = MESSAGE, supportLink = HELP) {
    const error = new Error(message);
    error.code = "CMYK_NOT_SUPPORTED";
    error.supportLink = supportLink;
    return error;
  }

  function responseError(payload = {}, fallback = "Request failed") {
    const message = payload.message || payload.error || fallback;
    const code = payload.error_code || payload.code || payload.error_type;
    return code === "CMYK_NOT_SUPPORTED" || code === "cmyk"
      ? cmykError(message, payload.support_link || HELP)
      : new Error(message);
  }

  function assertEligible(image) {
    if (needsRgb(image)) throw cmykError();
    return image;
  }

  function show(message = MESSAGE, supportLink = HELP) {
    ErrorPopupModule.showError(message, supportLink);
  }

  function badge(image) {
    return needsRgb(image)
      ? '<div class="library-image-print-block" style="position:absolute;left:8px;right:8px;bottom:8px;padding:6px 8px;border-radius:4px;background:rgba(32,32,32,.88);color:#fff;font-size:12px;font-weight:600;line-height:1.25;text-align:center;">Requires RGB re-upload</div>'
      : "";
  }

  window.CMYK = window.StackhouseCmykGuard = {
    HELP,
    MESSAGE,
    assert: assertEligible,
    badge,
    isError: (error) => error?.code === "CMYK_NOT_SUPPORTED",
    needs: needsRgb,
    responseError,
    show,
  };
})(window);
